import { PageTitleService } from "@/layout/service/page.title.service";
import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  TemplateRef,
  ViewEncapsulation,
} from "@angular/core";
import { DomainBaseComponent } from "./domain-base.component";

@Component({
  selector: "app-uni-page",
  templateUrl: "./uni-page.component.html",

  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UniPageComponent implements OnInit, OnChanges {
  @Input() parent: DomainBaseComponent;
  @Input() pageIcon: string;
  @Input() pageTitle: string;
  @Input() bodyTemplate: TemplateRef<any>;
  @Input() footerTemplate: TemplateRef<any>;
  @Input() showBack?: boolean;
  @Input() isDisabled?: boolean;

  constructor(private pageTitleService: PageTitleService) {}

  ngOnInit() {
    this.pageIcon = this.pageIcon ?? this.parent?.getPageIcon();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["pageTitle"]) {
      this.pageTitleService.setPageTitle(this.pageTitle);
    }
  }

  get hasHelp(): boolean {
    return !!this.hasMethod("showHelp");
  }

  hasMethod(methodName: string): boolean {
    return !!(this.parent as any)?.[methodName];
  }

  showHelp() {
    if (this.hasHelp) {
      (this.parent as any).showHelp();
    }
  }

  navigateBack() {
    this.parent?.goBack();
  }
}
